"use client";

import React from "react";
import { cn } from "utils/utils";
import { MoreVertical } from "lucide-react";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";
import { CollectionCard } from "modules/collections/details/model/collection";
import { TradeItem, TradeListType } from "modules/tradeLists/model/tradeList";
import { CollectionCardActionButtons } from "modules/collections/components/CollectionCardActionButtons";
import { TradeItemActionButtons } from "modules/tradeLists/components/TradeItemActionButtons";
import { useCardGridItemContext } from "./CardGridItemContext";

const BUTTON_BASE_CLASS =
  "btn btn-square btn-lg bg-base-100 border-base-content/20 text-primary absolute right-0 top-[4.5rem] rounded-full rounded-br-none rounded-tr-none border border-r-0 transition-opacity duration-300 ease-in-out";

interface CardGridItemOwnedActionsProps {
  collectionCard?: CollectionCard;
  tradeItem?: TradeItem;
  listType?: TradeListType;
  /** Consumer computes (was internal useAuth) */
  isOwner?: boolean;
  /** Consumer computes (was internal usePathname) */
  isFocusRoute?: boolean;
}

export function CardGridItemOwnedActions({
  collectionCard,
  tradeItem,
  listType,
  isOwner = false,
  isFocusRoute = false,
}: CardGridItemOwnedActionsProps) {
  const { selection } = useCardGridItemContext();

  const buttonClassName = cn(
    BUTTON_BASE_CLASS,
    selection.isAnySelected
      ? "pointer-events-none opacity-0"
      : "group-hover:opacity-100"
  );

  const icon = <MoreVertical className="ml-1.5" size={ICON_SIZE + 4} />;

  if (collectionCard) {
    return (
      <CollectionCardActionButtons
        card={collectionCard}
        buttonClassName={buttonClassName}
        icon={icon}
      />
    );
  }

  if (tradeItem && !isFocusRoute) {
    if (!isOwner) return null;

    return (
      <TradeItemActionButtons
        item={tradeItem}
        isOwner={true}
        listType={listType}
        buttonClassName={buttonClassName}
        icon={icon}
      />
    );
  }

  return null;
}
